<template>
    <div>
        <fullscreen-loading v-if="loading"/>

        <div class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <span class="h4">{{ $t('emailtemplate.title') }}</span>
                        </div>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm table-no-side-paddings table-striped">
                            <thead>
                            <tr>
                                <ordering @change="load()" v-model="order" field="name" tag="th">
                                    {{ $t('general.name') }}
                                </ordering>
                                <ordering @change="load()" v-model="order" field="subject" tag="th">
                                    {{ $t('general.subject') }}
                                </ordering>
                                <th />
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td>
                                    <input
                                        @change="load(1)"
                                        class="form-control form-control-filtering"
                                        type="text"
                                        v-model="filtering.name"
                                        :placeholder="$t('emailtemplate.search_name')"
                                    />
                                </td>
                                <td>
                                    <input
                                        @change="load(1)"
                                        class="form-control form-control-filtering"
                                        type="text"
                                        v-model="filtering.subject"
                                        :placeholder="$t('emailtemplate.search_subject')"
                                    />
                                </td>
                                <td />
                            </tr>

                            <tr v-for="emailTemplate of emailTemplates.data" :key="emailTemplate.id">
                                <td>{{ emailTemplate.name }}</td>
                                <td>{{ emailTemplate.subject }}</td>
                                <td class="text-right">
                                    <router-link
                                        class="btn btn-xs btn-primary"
                                        tag="button"
                                        :to="{ name: 'email_template', params: { id: emailTemplate.id } }"
                                    >
                                        {{ $t('general.edit') }}
                                    </router-link>
                                </td>
                            </tr>

                            <tr v-if="emailTemplates.data.length === 0 && !loading">
                                <td colspan="3" class="no-results">{{ $t('emailtemplate.no_results') }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-footer border-0">
                        <Pagination :pagination="emailTemplates" @change="load()" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Pagination from "../../components/Pagination";
    import FullscreenLoading from "../../components/FullscreenLoading";
    import Ordering from "../../components/Ordering";
    import filteringFromObject from "../../utils/filteringFromObject";

    export default {

        components: {
            Pagination,
            FullscreenLoading,
            Ordering
        },

        data() {
            return {
                loading: false,
                emailTemplates: {
                    current_page: 1,
                    data: []
                },

                order: 'created_at,desc',
                filtering: {
                    name: null,
                    subject: null
                }
            }
        },

        created(){
            this.load(1);
        },

        methods: {
            async load(page) {
                if(page){
                    this.emailTemplates.current_page = page;
                }

                this.loading = true;

                try {
                    const response = await this.$http.get('/api/email-templates', {
                        params: {
                            page: this.emailTemplates.current_page,
                            order: this.order,
                            filters: filteringFromObject(this.filtering)
                        }
                    });

                    this.emailTemplates = response.data;
                } catch (exception) {
                    if(!exception.response || (exception.response && exception.response.status !== 401)) {
                        alert('Failed to load email templates');
                    }
                }

                this.loading = false;
            }
        }
    }

</script>
